// @ts-nocheck

import React, { useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { flashMessageActionCreators } from '../../actions';
import useMergeProps from '../../hooks/useMergeProps';

import ToastrFactory from './ToastrFactory';
import selectToastrFactoryProps from './ToastrFactory.selector';

type ToastrFactoryContainerProps = {
  className?: string;
};

const ToastrFactoryContainer = (ownProps: ToastrFactoryContainerProps) => {
  const dispatch = useDispatch();

  const selectedProps = useSelector(selectToastrFactoryProps);

  const delMessage = useCallback(
    ({ scope, id }) => {
      dispatch(flashMessageActionCreators.delMessage({ scope, id }));
    },
    [dispatch],
  );

  const otherProps = useMemo(
    () => ({
      delMessage,
    }),
    [delMessage],
  );

  const enhancedProps = useMergeProps({ ownProps, selectedProps, otherProps });

  return <ToastrFactory {...enhancedProps} />;
};

export default ToastrFactoryContainer;
